// document.addEventListener('change', function (e) {

//   if (!e.target.classList.contains('variant-option')) return;

//   const selectedOptions = [];

//   document.querySelectorAll('.variant-option:checked').forEach(input => {
//     selectedOptions.push(input.value);
//   });
//   console.log("selectedOptions",selectedOptions)
//   const currentVariant = productVariants.find(variant =>
//     variant.options.every((option, index) =>
//       option === selectedOptions[index]
//     )
//   );

//    if (currentVariant) {
//     console.log(currentVariant);

//     const url = new URL(window.location.href);
//     url.searchParams.set('variant', currentVariant.id);

//     window.history.replaceState({}, '', url);
//   }
// });
// document.addEventListener('change', function (e) {
//     const data = window.data;
//     console.log("data",data)
//     if (!e.target.classList.contains('variant-option')) return;

//     const selectedOptions = [];

//     document.querySelectorAll('.variant-option:checked').forEach(input => {
//         selectedOptions.push(input.value);
//     });

//     const currentVariant = data.find(variant =>
//         variant.options.every((option, index) =>
//         option === selectedOptions[index]
//         )
//     );
//     console.log("data",data)
//     console.log("currentVariant",currentVariant)
// });
// document.addEventListener('DOMContentLoaded', () => {

//   window.data.forEach(variant => {

//     if (variant.available === false) {

//       variant.options.forEach(optionValue => {

//         document
//           .querySelectorAll(`[data-value="${optionValue}"]`)
//           .forEach(el => {
//             el.classList.add('unselectable');

//             const input = el.querySelector('.variant-option');
//             if (input) {
//               input.disabled = true;
//             }
//           });

//       });

//     }

//   });

// });


// document.addEventListener('DOMContentLoaded', () => {
//   const variants = window.productVariants || [];

//   function updateUnavailableOptions() {
//     const selectedOptions = [];

//     document.querySelectorAll('.variant-option:checked').forEach((input) => {
//       const wrapper = input.closest('[data-option-position]');
//       const position = Number(wrapper.dataset.optionPosition);

//       selectedOptions[position - 1] = input.value;
//     });

//     document.querySelectorAll('[data-option-position]').forEach((optionEl) => {
//       const position = Number(optionEl.dataset.optionPosition);
//       const value = optionEl.dataset.value;

//       const matchingVariants = variants.filter((variant) => {
//         // Current option value being checked
//         if (variant[`option${position}`] !== value) {
//           return false;
//         }

//         // Match all other selected options
//         for (let i = 1; i <= 3; i++) {
//           if (
//             selectedOptions[i - 1] &&
//             i !== position &&
//             variant[`option${i}`] !== selectedOptions[i - 1]
//           ) {
//             return false;
//           }
//         }

//         return true;
//       });

//       const available = matchingVariants.some((variant) => variant.available);
//       console.log("available",available);

//       optionEl.classList.toggle('unselectable', !available);

//       const input = optionEl.querySelector('input');
//       if (input) {
//         input.disabled = !available;
//       }
//     });
//   }

//   // Initial load
//   updateUnavailableOptions();

//   // Recalculate whenever an option changes
//   document.addEventListener('change', (e) => {
//     if (e.target.classList.contains('variant-option')) {
//       setTimeout(updateUnavailableOptions, 0);
//     }
//   });

//   // Recalculate when Shopify updates variant
//   document.addEventListener('variant:change', () => {
//     updateUnavailableOptions();
//   });
// });

// class VariantSelects extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     this.addEventListener('change', (event) => {
//     const target = this.getInputForEventTarget(event.target);
//     //   this.updateSelectionMetadata(event);
//     const productUrl = this.dataset.productUrl;

//      this.renderProductInfo({
//           requestUrl: this.buildRequestUrlWithParams(productUrl,this.selectedOptionValues),
//           targetId: target.id,
//           productUrl: productUrl
//         });
//     });
//   }

//     renderProductInfo({ requestUrl, targetId, productUrl }) {
//         fetch(requestUrl)
//           .then((response) => response.text())
//           .then((responseText) => {
//             const html = new DOMParser().parseFromString(responseText, 'text/html');
//             this.handleUpdateProductInfo(html, productUrl);
//           })
//           .then(() => {
//             // set focus to last clicked option value
//             document.querySelector(`#${targetId}`)?.focus();
//           })
//           .catch((error) => {
//             if (error.name === 'AbortError') {
//               console.log('Fetch aborted by user');
//             } else {
//               console.error(error);
//             }
//           });
//     }

//        handleUpdateProductInfo(html, productUrl) {
//         const variant = this.getSelectedVariant(html);
//           console.log("variant",variant);

//         //   this.updateOptionValues(html);
//         //   this.updateVariantInputs(variant?.id);

//           if (!variant) {
//             this.setUnavailable();
//             return;
//           }

//           const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
//             const source = html.getElementById(`${id}-${this.dataset.section}`);
//             console.log("source",source);
//             const destination = document.querySelector(`#${id}-${this.dataset.section}`);
//             console.log("destination",destination);
//             if (source && destination) {
//               destination.innerHTML = source.innerHTML;
//               destination.classList.toggle('hidden', shouldHide(source));
//             }
//           };
//           updateSourceFromDestination('price');
//           updateSourceFromDestination('variant-selects');
//         window.history.replaceState({}, '', `${productUrl}${variant.id ? `?variant=${variant.id}` : ''}`);
//       }

//     getSelectedVariant(productInfoNode) {
//         const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
//         return !!selectedVariant ? JSON.parse(selectedVariant) : null;
//     }

//     buildRequestUrlWithParams(url, optionValues) {
//         const params = [];
//         params.push(`section_id=${this.dataset.section}`);

//         if (optionValues.length) {
//           params.push(`option_values=${optionValues.join(',')}`);
//         }

//         return `${url}?${params.join('&')}`;
//       }

//   updateSelectionMetadata({ target }) {
//     const { value, tagName } = target;
//       const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
//       if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
//   }

//   getInputForEventTarget(target) {
//     return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
//   }

//   get selectedOptionValues() {
//     return Array.from(this.querySelectorAll('.check-box-inner > ul input:checked')).map(
//       ({ dataset }) => dataset.optionValueId
//     );
//   }
// }

// customElements.define('variant-selects', VariantSelects);

class VariantSelects extends HTMLElement {
  #abortController = null;
  #debounceTimer   = null;
  static #DEBOUNCE_MS = 100;

  connectedCallback() {
    this._onChange = this.#handleChange.bind(this);
    this.addEventListener('change', this._onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this._onChange);
    this.#abortController?.abort();
  }

  #handleChange({ target }) {
    clearTimeout(this.#debounceTimer);
    this.#debounceTimer = setTimeout(() => this.#fetchProductInfo(target.id), VariantSelects.#DEBOUNCE_MS);
  }

  async #fetchProductInfo(targetId) {
    this.#abortController?.abort();
    this.#abortController = new AbortController();

    const { productUrl, section } = this.dataset;
    const params = new URLSearchParams({ section_id: section });
    const values = this.selectedOptionValues;
    if (values.length) params.set('option_values', values.join(','));

    try {
      const res  = await fetch(`${productUrl}?${params}`, { signal: this.#abortController.signal });
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      this.#updateProductInfo(html, productUrl);
      document.getElementById(targetId)?.focus();
    } catch (err) {
      if (err.name !== 'AbortError') console.error(err);
    }
  }

  #updateProductInfo(html, productUrl) {
    const raw     = html.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
    const variant = raw ? JSON.parse(raw) : null;

    // if (!variant) { this.setUnavailable(); return; }
    ['price', 'mobprice', 'variant-selects' , 'MediaGallery' , 'ProductInquiryData'].forEach((id) => {
      const key  = `${id}-${this.dataset.section}`;
      const src  = html.getElementById(key);
      const dest = document.getElementById(key);
      if (src && dest) dest.innerHTML = src.innerHTML;
    });
    
    
    var pdpThumb = new Swiper(".pdp-thumb", {
    centeredSlides: true,
    centeredSlidesBounds: true,
    direction: "horizontal",
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    breakpoints: {
      480: {
        direction: "vertical",
        slidesPerView: 6,
        spaceBetween: 8,
      },
    },
  });
  var pdpSlider = new Swiper(".pdp-slider", {
    direction: "horizontal",
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: pdpThumb,
    },
  });
  Fancybox.bind("[data-fancybox]", {
    Carousel: {
      Thumbs: {
        type: "classic",
      },
    },
  });
    window.history.replaceState({}, '', variant.id ? `${productUrl}?variant=${variant.id}` : productUrl);
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('.check-box-inner > ul input:checked'))
      .map(({ dataset }) => dataset.optionValueId);
  }

}

customElements.define('variant-selects', VariantSelects);